/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-item/product-section-item-plantlife/product-section-item-plantlife.component.scss */
::ng-deep .force-italic-style * {
  font-style: italic !important;
}
/*# sourceMappingURL=product-section-item-plantlife.component.css.map */
